export default __webpack_public_path__ + "static/media/benefitsRight.aa38d3c2.png";